import * as React from 'react';

import Space from 'antd/lib/space';
import Typography from 'antd/lib/typography';

import { PetPrice } from '@app/objects/PetPrice';

interface PetServiceNameViewProps {
	record: PetPrice;
	withCount?: boolean;
}

/**
 * Component to display service name
 * If service is part of preset - display preset name as well
 * @param props
 * @constructor
 */
export const PetServiceNameView: React.FC<PetServiceNameViewProps> = (props: PetServiceNameViewProps) => {
	let name = props.record.name;
	const parent = props.record.parent?.name;

	if (props.withCount) {
		name = `${name} x ${props.record.count}`;
	}

	return (
		<Space
			direction="vertical"
			size={0}
		>
			<Typography.Text>
				{name}
			</Typography.Text>
			{
				parent
					? <Typography.Text type="secondary">{parent}</Typography.Text>
					: null
			}
		</Space>
	);
};
